<!-- This example requires Tailwind CSS v2.0+ -->
<template>
  <div>
    <router-link to="/plans" class="ml-1 text-sm font-medium text-primary">
      <div class="flex items-center">
        <ChevronLeftIcon class="shrink-0 h-5 w-5" aria-hidden="true" />
        Mes contrats
      </div>
    </router-link>
    <template v-if="plan?.friendlyId">
      <InsuranceInformation class="mt-6" :plan="plan" />
      <InsuredProductsInformation class="mt-6" :plan="plan" :claims="pastClaims" @refreshPlanSale="refreshPlanSale" />
      <PlanSaleDocuments class="mt-6" :plan="plan" />
      <ClaimIndex class="my-6" :claims="pastClaims" />
    </template>
    <Loading v-else />
  </div>
</template>

<script>
import { ChevronLeftIcon } from "@heroicons/vue/solid";
import { mapActions } from "vuex";
import { Loading } from "@estaly/ui";
import ClaimIndex from "@/components/claim/ClaimIndex.vue";
import PlanSaleDocuments from "@/components/plan/PlanSaleDocuments.vue";
import InsuranceInformation from "@/views/plan/InsuranceInformation.vue";
import InsuredProductsInformation from "@/views/plan/InsuredProductsInformation.vue";
import { toCamelCase } from "@estaly/ui";

export default {
  components: {
    InsuredProductsInformation,
    InsuranceInformation,
    PlanSaleDocuments,
    ChevronLeftIcon,
    ClaimIndex,
    Loading,
  },

  async created() {
    await this.loadPlan();
  },

  data() {
    return {
      plan: {},
    };
  },

  computed: {
    pastClaims() {
      return this.plan?.claims ?? [];
    },
  },

  watch: {
    "$route.params.id"(value) {
      if (value) this.loadPlan();
    },
  },

  methods: {
    ...mapActions("customer", ["getPlan", "withLoader"]),
    ...mapActions("notifications", ["notify"]),

    async loadPlan() {
      await this.withLoader(async () => {
        const response = await this.getPlan(this.$route.params.id);
        if (!response?.success) return;
        this.plan = toCamelCase(response.data);
      });
    },

    async refreshPlanSale() {
      await this.loadPlan();
    },
  },
};
</script>
